import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { products } from '../../data/products';
import ProductImageGallery from '../../components/ProductImageGallery';
import { useCart } from '../../context/CartContext';

const SwitchACAdapter = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [activeTab, setActiveTab] = useState('overview');
  const [currentImage, setCurrentImage] = useState('');
  const [selectedPlug, setSelectedPlug] = useState('EU');
  const [quantity, setQuantity] = useState(1);
  
  // 获取Switch AC Adapter产品数据
  const adapter = products.find(p => p.name === 'Nintendo Switch 2 Power Adapter – 60W GaN PD Charger for Dock & Console');
  
  // 更多图片
  const additionalImages = [
    "/images/shop-products/switch-ac-adapter/switch 2 ac adapter.jpg",
    "/images/shop-products/switch-ac-adapter/Screenshot 2025-05-27 011410.png",
    "/images/shop-products/switch-ac-adapter/Screenshot 2025-05-27 011415.png",
    "/images/shop-products/switch-ac-adapter/Screenshot 2025-05-27 011428.png",
    "/images/shop-products/switch-ac-adapter/Screenshot 2025-05-27 011431.png",
    "/images/shop-products/switch-ac-adapter/Screenshot 2025-05-27 011436.png",
    "/images/shop-products/switch-ac-adapter/Screenshot 2025-05-27 012133.png"
  ];

  // 初始化当前图片
  useEffect(() => {
    setCurrentImage(adapter.image);
  }, [adapter.image]);

  // 添加到购物车
  const handleAddToCart = () => {
    const productToAdd = {
      ...adapter,
      selectedPlug,
      quantity
    };
    addToCart(productToAdd);
  };

  // 立即购买
  const handleBuyNow = () => {
    const productToAdd = {
      ...adapter,
      selectedPlug,
      quantity
    };
    addToCart(productToAdd);
    navigate('/cart');
  };

  // 相关产品
  const relatedProducts = products.filter(p => 
    p.name !== 'Nintendo Switch 2 Power Adapter – 60W GaN PD Charger for Dock & Console' && 
    (p.category === 'nintendo-switch' || p.category === 'accessories')
  ).slice(0, 4);

  return (
    <div className="container mx-auto px-4 py-12 text-white">
      {/* 面包屑导航 */}
      <div className="text-sm text-gray-400 mb-6">
        <Link to="/" className="hover:text-white">Home</Link> / 
        <Link to="/shop" className="hover:text-white mx-2">Shop</Link> / 
        <Link to="/shop/nintendo-switch" className="hover:text-white mr-2">Nintendo Switch</Link> / 
        <span className="text-white">{adapter.name}</span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* 左侧产品图片 */}
        <div>
          <ProductImageGallery
            images={additionalImages}
            currentImage={currentImage}
            onImageChange={setCurrentImage}
          />
        </div>
        
        {/* 右侧产品信息 */}
        <div>
          <h1 className="text-3xl font-bold mb-2">{adapter.name}</h1>
          
          {/* 评分 */}
          <div className="flex items-center mb-4">
            <div className="flex text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={i < Math.floor(adapter.rating) ? "text-yellow-400" : "text-gray-600"}>★</span>
              ))}
            </div>
            <span className="ml-2 text-gray-400">({adapter.reviews} reviews)</span>
          </div>
          
          {/* 价格 */}
          <div className="mb-6">
            <span className="text-3xl font-bold">{adapter.price}</span>
            {adapter.originalPrice && (
              <span className="ml-3 text-gray-400 line-through">{adapter.originalPrice}</span>
            )}
            {adapter.originalPrice && (
              <span className="ml-3 bg-red-600 text-white px-2 py-1 rounded-md text-sm">
                Save S${(parseFloat(adapter.originalPrice.replace(/^S\$/, '')) - parseFloat(adapter.price.replace(/^S\$/, ''))).toFixed(2)}
              </span>
            )}
          </div>
          
          {/* 库存状态 */}
          <div className="mb-6">
            {adapter.inStock ? (
              <span className="text-green-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                In Stock
              </span>
            ) : (
              <span className="text-red-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                Out of Stock
              </span>
            )}
          </div>
          
          {/* 简短描述 */}
          <p className="text-gray-300 mb-6">{adapter.description}</p>
          
          {/* 选择插头类型 */}
          <div className="mb-6">
            <h3 className="text-lg font-medium mb-3">Plug Type</h3>
            <div className="grid grid-cols-2 gap-3">
              {[
                { name: 'EU', description: 'European Plug', available: true },
                { name: 'US', description: 'US Plug', available: false },
                { name: 'UK', description: 'UK Plug', available: false },
                { name: 'AU', description: 'Australian Plug', available: false }
              ].map((plug) => (
                <button 
                  key={plug.name}
                  className={`border-2 ${plug.name === selectedPlug ? 'border-green-500' : plug.available ? 'border-gray-700 hover:border-green-500' : 'border-red-700 cursor-not-allowed opacity-50'} 
                    rounded-md py-3 px-4 text-center transition-colors ${!plug.available ? 'cursor-not-allowed' : ''}`}
                  onClick={() => plug.available && setSelectedPlug(plug.name)}
                  disabled={!plug.available}
                >
                  <div className="font-medium">{plug.name}</div>
                  <div className="text-sm text-gray-400">{plug.description}</div>
                  {!plug.available && (
                    <div className="text-xs text-red-400 mt-1">Sold Out</div>
                  )}
                </button>
              ))}
            </div>
          </div>
          
          {/* Quantity */}
          <div className="mb-8">
            <h3 className="text-lg font-medium mb-3">Quantity</h3>
            <div className="flex items-center">
              <button 
                className="bg-gray-800 px-4 py-2 rounded-l-md"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
              >
                -
              </button>
              <input 
                type="text" 
                value={quantity} 
                readOnly
                className="bg-gray-800 text-center w-16 py-2 border-x border-gray-700"
              />
              <button 
                className="bg-gray-800 px-4 py-2 rounded-r-md"
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </button>
            </div>
          </div>
          
          {/* Purchase Buttons */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <button 
              onClick={handleAddToCart}
              className="bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-md font-medium"
            >
              Add to Cart
            </button>
            <button 
              onClick={handleBuyNow}
              className="bg-gray-800 hover:bg-gray-700 text-white py-3 px-6 rounded-md font-medium border border-gray-600"
            >
              Buy Now
            </button>
          </div>
          
          {/* Shipping Info */}
          <div className="border-t border-gray-700 pt-6">
            <div className="flex items-center mb-3">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2a1 1 0 00.9-.5l1.5-2A1 1 0 0015 7h-3V4a1 1 0 00-1-1H3zM14 7l-1.5 2H10V5h4v2z" />
              </svg>
              <span className="text-gray-300">Free Meet Up (Available at Sengkang & Orchard locations)</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              <span className="text-gray-300">Available Shipping</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* 产品详情选项卡 */}
      <div className="mt-16">
        <div className="border-b border-gray-700 mb-8">
          <div className="flex space-x-8">
            <button 
              onClick={() => setActiveTab('overview')}
              className={`pb-4 px-2 font-medium ${activeTab === 'overview' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Overview
            </button>
            <button 
              onClick={() => setActiveTab('specs')}
              className={`pb-4 px-2 font-medium ${activeTab === 'specs' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Specifications
            </button>
            <button 
              onClick={() => setActiveTab('reviews')}
              className={`pb-4 px-2 font-medium ${activeTab === 'reviews' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Reviews ({adapter.reviews})
            </button>
          </div>
        </div>
        
        {/* 选项卡内容 */}
        <div>
          {activeTab === 'overview' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Product Overview</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div>
                  <p className="text-gray-300 mb-6">
                    The official Nintendo Switch AC Adapter provides reliable and fast charging for your 
                    Nintendo Switch console. This premium adapter ensures your gaming sessions are never 
                    interrupted by low battery, delivering consistent power for both handheld and docked play.
                  </p>
                  <p className="text-gray-300 mb-6">
                    Built with Nintendo's strict quality standards, this adapter features advanced safety 
                    protection circuits to prevent overcharging, overheating, and short circuits. The 
                    compact design makes it perfect for travel, while the 1.5-meter cable provides 
                    flexibility in your gaming setup.
                  </p>
                  <p className="text-gray-300">
                    Compatible with all Nintendo Switch models, this adapter delivers optimal charging 
                    performance whether you're playing in handheld mode or using the Nintendo Switch dock. 
                    The LED indicator provides clear charging status feedback.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-4">Key Features</h3>
                  <ul className="space-y-4">
                    {adapter.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <svg className="w-6 h-6 mr-2 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <div>
                          <span className="font-medium">{feature}</span>
                          <p className="text-gray-400 text-sm mt-1">
                            {feature === "Official Nintendo Product" && "Genuine Nintendo quality and compatibility"}
                            {feature === "Fast Charging" && "Optimized charging speed for quick power-ups"}
                            {feature === "Safety Protection" && "Built-in protection against overcharging and overheating"}
                            {feature === "Compact Design" && "Portable and lightweight for easy travel"}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
          
          {activeTab === 'specs' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Technical Specifications</h2>
              <div className="bg-gray-800 rounded-lg p-6">
                <table className="w-full">
                  <tbody>
                    {Object.entries(adapter.specs).map(([key, value], index) => (
                      <tr key={index} className={index !== 0 ? "border-t border-gray-700" : ""}>
                        <td className="py-4 pr-4 font-medium w-1/3">{key}</td>
                        <td className="py-4 text-gray-300">{value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          
          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Customer Reviews</h2>
              <div className="flex items-center mb-8">
                <div className="mr-4">
                  <div className="text-5xl font-bold">{adapter.rating}</div>
                  <div className="flex text-yellow-400 mt-2">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className={i < Math.floor(adapter.rating) ? "text-yellow-400" : "text-gray-600"}>★</span>
                    ))}
                  </div>
                  <div className="text-sm text-gray-400 mt-1">Based on {adapter.reviews} reviews</div>
                </div>
                <div className="flex-1 ml-6">
                  {[5, 4, 3, 2, 1].map((star) => (
                    <div key={star} className="flex items-center mb-2">
                      <div className="w-12 text-sm text-gray-400">{star} stars</div>
                      <div className="w-full bg-gray-700 rounded-full h-2 mx-2">
                        <div 
                          className="bg-yellow-400 h-2 rounded-full" 
                          style={{ 
                            width: `${star === 5 ? 75 : star === 4 ? 15 : star === 3 ? 7 : star === 2 ? 2 : 1}%` 
                          }}
                        ></div>
                      </div>
                      <div className="w-12 text-sm text-right text-gray-400">
                        {star === 5 ? '75%' : star === 4 ? '15%' : star === 3 ? '7%' : star === 2 ? '2%' : '1%'}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* 示例评论 */}
              <div className="space-y-6">
                {[
                  { name: "Sarah L.", rating: 5, date: "2 days ago", comment: "Perfect replacement for my original Switch adapter. Charges quickly and the build quality is excellent. The LED indicator is very helpful to know when it's charging properly." },
                  { name: "Mike R.", rating: 5, date: "1 week ago", comment: "Official Nintendo product, works exactly like the original. Fast shipping and great packaging. Highly recommend for anyone who needs a reliable Switch charger." },
                  { name: "Jennifer K.", rating: 4, date: "2 weeks ago", comment: "Great adapter, charges my Switch quickly. The cable length is perfect for my setup. Only minor issue is the cable could be a bit more flexible, but overall very satisfied." }
                ].map((review, index) => (
                  <div key={index} className="border-b border-gray-700 pb-6">
                    <div className="flex justify-between mb-2">
                      <span className="font-medium">{review.name}</span>
                      <span className="text-gray-400 text-sm">{review.date}</span>
                    </div>
                    <div className="flex text-yellow-400 mb-2">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className={i < review.rating ? "text-yellow-400" : "text-gray-600"}>★</span>
                      ))}
                    </div>
                    <p className="text-gray-300">{review.comment}</p>
                  </div>
                ))}
              </div>
              
              {/* 查看更多评论按钮 */}
              <div className="mt-8 text-center">
                <button className="bg-gray-800 hover:bg-gray-700 text-white py-3 px-6 rounded-md font-medium">
                  Load More Reviews
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {/* 相关产品 */}
      <div className="mt-20">
        <h2 className="text-2xl font-bold mb-8">You May Also Like</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {relatedProducts.map(product => (
            <div key={product.id} className="bg-gray-800 rounded-lg overflow-hidden">
              <img src={product.image} alt={product.name} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="font-medium mb-2">{product.name}</h3>
                <div className="flex justify-between items-center">
                  <span className="font-bold">${product.price}</span>
                  <button className="bg-green-600 hover:bg-green-700 text-white py-1 px-3 rounded-md text-sm">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SwitchACAdapter;